module.exports = "/images/left.svg?c8f111d323aed97a79128e0d42ccc4a8";